export const getSearchInitializedProps = () => ({
    eventCategory: 'event_category',
    firstThreeCharacters: 'first_three_characters'
});

export const getSearchOpenedProps = () => ({
    eventCategory: 'event_category',
    topNavPillActive: 'top_nav_pill_active'
});

export const getSearchResultsReturnedProps = () => ({
    eventCategory: 'event_category',
    searchKeyword: 'search_keyword',
    totalSearchResults: 'total_search_results',
    searchMlModelVersion: 'search_ml_model_version'
});

export const getSearchResultsSelectedProps = () => ({
    position: 'position',
    eventCategory: 'event_category',
    searchKeyword: 'search_keyword',
    totalSearchResults: 'total_search_results',
    searchMlModelVersion: 'search_ml_model_version'
});
